import { View } from 'rune-ts';

class UiError extends Error {
  constructor(view: View, message: string) {
    super(`${view}: ${message}`);
  }
}

export class BeforeRenderError extends UiError {
  constructor(view: View) {
    super(view, 'BeforeRenderError');
  }
}

export class RequiredValueEmptyError extends UiError {
  constructor(view: View, value_key: string) {
    super(view, `RequiredValueEmptyError => ${value_key}`);
  }
}

export class RequiredParentViewError extends UiError {
  constructor(view: View) {
    super(view, `RequiredParentViewError`);
  }
}

export class NavigationHistoryEmptyError extends UiError {
  constructor(view: View) {
    super(view, `NavigationHistoryEmptyError`);
  }
}
